import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { combineLatest, map, take } from 'rxjs';
import { AuthStateService } from '../services/auth-state.service';

export const isAuthenticated = () => {
    const oidcSecurityService = inject(OidcSecurityService);
    const router = inject(Router);
    const authStateService = inject(AuthStateService);

    return combineLatest([
        oidcSecurityService.isAuthenticated$,
        authStateService.isAuthCheckComplete$,
        authStateService.isAuthorizationInProgress$,
    ]).pipe(
        take(1),
        map(([{ isAuthenticated }, isAuthCheckComplete, isAuthorizationInProgress]) => {
            // If auth check is not complete, show verifying session page
            if (!isAuthCheckComplete) {
                return router.parseUrl('/verifying-session');
            }

            // If authorization is in progress, keep showing verifying session
            if (isAuthorizationInProgress) {
                return router.parseUrl('/verifying-session');
            }

            // allow navigation if authenticated
            if (isAuthenticated) {
                return true;
            }

            // redirect if not authenticated (only after auth check is complete and not in progress)
            return router.parseUrl('/unauthorized');
        })
    );
};
